import { render, staticRenderFns } from "./Rechtsgebieden.vue?vue&type=template&id=1fd70edc"
import script from "./Rechtsgebieden.vue?vue&type=script&lang=js"
export * from "./Rechtsgebieden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_cache-loader@4.1.0_webpack@4.47.0__css-load_cf268ff5aae9e16024c4379f26d676ef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports